// extracted by mini-css-extract-plugin
export default {"tagline":"ForgottenPassword_tagline__VL2su","titleContainer":"ForgottenPassword_titleContainer__Fgf1-","title":"ForgottenPassword_title__Me0gG"};